<template>
  <div>
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button @click="$emit('close')" color="primary" type="border" icon-pack="feather"
          icon="icon-arrow-left"></vs-button>
      </vs-col>
    </vs-row>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <vx-card v-if="checkifSubjectContainResb()">
          <resb @showData="(data) => showData(data)" :resbData="resbData" :resbgsCount="resbgsCount"
            :resbgrCount="resbgrCount" :resbTotal="resbTotal">
          </resb>
        </vx-card>

        <vx-card v-else>
          <reem @showData="(data) => showData(data)" :reemData="resbData" :reemgsCount="resbgsCount"
            :reemgrCount="resbgrCount" :reemTotal="resbTotal">
          </reem>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-2/3">
        <div class="col-md-12">
          <StockTable :filter="mainFilter" uploadEndpoint="/uploadFile" endPoint="getCombineTableForGRandGS"
            filterEndpoint="getCombineTableForGRandGS" key="getCombineTableForGRandGS"></StockTable>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import resb from './resb.vue';
import reem from './reem.vue';
import StockTable from "@/components/aron/table/combineMovementTable.vue";
export default {
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    resb,
    StockTable,
    reem

  },
  props: {
    subject: {
      type: [Number, String],
      default: "",
    },
    resbTotal: {
      type: [Number, String],
      default: "",
    },
    resbgrCount: {
      type: [Number, String],
      default: "",
    },
    dateFrom: {
      type: Date,
      default: "",
    },
    dateTo: {
      type: Date,
      default: "",
    },
    resbgsCount: {
      type: [Number, String],
      default: "",
    }, resbData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
    };
  },
  methods: {
    extractDateFromObject(dateObject) {
      if (dateObject instanceof Date) {
        const dateString = dateObject.toISOString();
        return dateString.substring(0, 10);
      } else {
        console.log("Invalid date object");
        // Handle the error or set a default value
        return null; // or any other default value
      }
    },
    showData(subject) {
      this.$emit("resetMe", subject);
    },
    checkifSubjectContainResb() {
      //check if subject is contain the word resb
      var char = "resb";
      if (this.subject.toLowerCase().includes(char.toLowerCase())) {
        return true;
      }
      return false;
    },
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getData() {
      this.startLoading();
      this.aronPost('getCombineTableForGRandGS', {}, '', '')
        .then(response => {
          if (response.status) {
            console.log("response.data:", response.data);
          } else {
            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })
    },
  },
  computed: {
    mainFilter() {
      var sub = "REEM";
      var type = this.subject.replace(new RegExp('Reem', 'g'), '');
      type = type.replace(new RegExp('Resb', 'g'), '');

      var char = "resb";
      if (this.subject.toLowerCase().includes(char.toLowerCase())) {
        sub = "RESB";
      }

      return { dateFrom: this.extractDateFromObject(this.dateFrom), dateTo: this.extractDateFromObject(this.dateTo), type: type, compId: sub }
    }
  },
  mounted() {
    //this.getData();
  },
  created() {

  }
};
</script>
